<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/productlist"></ion-back-button>
    </ion-buttons>
    <!-- <ion-buttons slot="start"> -->
      <!-- <ion-back-button (click)="close()"> -->
        
      <!-- </ion-back-button> -->
    <!-- </ion-buttons> -->
    <ion-title class="title"><ion-icon (click)="close()" name="arrow-back-outline"></ion-icon> <span>Product Setting</span></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <h5 class="pl10">Additional Product Fields</h5>
<ion-list>
  <ion-item>
    <ion-label>Tax</ion-label>
    <ion-toggle [checked]="db.product_set.tax" (ionChange)="db.product_set.tax = crazyEvent($event)" mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <ion-item>
    <ion-label>SKU</ion-label>
    <ion-toggle [checked]="db.product_set.sku" (ionChange)="db.product_set.sku = crazyEvent($event)" mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <ion-item>
    <ion-label>Is Featured Product</ion-label>
    <ion-toggle [checked]="db.product_set.display_home_page" (ionChange)="db.product_set.display_home_page = crazyEvent($event)" mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <ion-item>
    <ion-label>Is gift card</ion-label>
    <ion-toggle [checked]="db.product_set.is_gift_card" (ionChange)="db.product_set.is_gift_card = crazyEvent($event)" mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <ion-item>
    <ion-label>Brand</ion-label>
    <ion-toggle mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <!-- <ion-item>
    <ion-label>Short Description</ion-label>
    <ion-toggle (ionChange)="crazyEvent($event)" mode="ios" slot="end"></ion-toggle>
  </ion-item> -->
  <ion-item>
    <ion-label>Description</ion-label>
    <ion-toggle [checked]="db.product_set.description" (ionChange)="db.product_set.description = crazyEvent($event)" mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <ion-item>
    <ion-label>Minimum Order Qty</ion-label>
    <ion-toggle mode="ios" slot="end"></ion-toggle>
  </ion-item>
  <ion-item>
    <ion-label>Maximum Order Qty</ion-label>
    <ion-toggle mode="ios" slot="end"></ion-toggle>
  </ion-item>
</ion-list>
</ion-content>
